import { render, staticRenderFns } from "./Home.main.vue?vue&type=template&id=7fa0c5b1"
import script from "./Home.main.vue?vue&type=script&lang=js"
export * from "./Home.main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports